/* global $ */

(function (scope) {
  "use strict";

  var PrintToolsView = (scope.PrintToolsView = function (controller, design) {
    this.controller = controller;
    this.design = design;
    this.$el = $("#PrintToolsView");
    this.$el.on(
      "click",
      "a:not(.disabled):not(.active)",
      this.toolChanged.bind(this)
    );
    this.$el.on(
      "click",
      "a.disabled",
      this.displayInfoOnDisabledTool.bind(this)
    );
  });

  PrintToolsView.prototype.toolChanged = function (e) {
    e.preventDefault();

    var tool = $(e.currentTarget).data("tool");
    this.controller.switchTool(tool);
  };

  PrintToolsView.prototype.displayInfoOnDisabledTool = function (e) {
    e.preventDefault();
    this.controller.notify(
      "info",
      sculpteo.INFO.DISABLED_TOOL_CLICK,
      true,
      gettext($(e.currentTarget).data("info"))
    );
  };

  PrintToolsView.prototype.setActive = function (tool) {
    $("a", this.$el).removeClass("active");
    $("[data-tool=" + tool + "]").toggleClass("active");
  };

  /**
   * Mark tool as enabled => do domething on the model. Like thickening.
   * @param {string} tool
   * @param {bool} enabled
   */
  PrintToolsView.prototype.setEnabled = function (tool, enabled) {
    $("[data-tool=" + tool + "]").toggleClass("enabled", enabled);
  };

  PrintToolsView.prototype.toggle = function (tool, enabled) {
    $("[data-tool=" + tool + "]").toggleClass("disabled", !enabled);
  };

  PrintToolsView.TOOLS = {};
  PrintToolsView.TOOLS.DASHBOARD = "dashboard";
  PrintToolsView.TOOLS.ORIENTATION = "orientation";
  PrintToolsView.TOOLS.BATCH_CONTROL = "batch";
  PrintToolsView.TOOLS.HOLLOWING = "hollowing";
  PrintToolsView.TOOLS.THICKENING = "thickening";
  PrintToolsView.TOOLS.ANNOTATIONS = "annotations";
  PrintToolsView.TOOLS.SLICER = "slicer";
})((window.sculpteo = window.sculpteo || {}));
